import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".swiper-box .swiper", {
  autoplay: {
        delay: 4000,
        disableOnInteraction: false,
	},
	speed:700,
	loop:true,//必须
      navigation: {
        nextEl: ".swiper-box .swiper-button-next",
        prevEl: ".swiper-box .swiper-button-prev",
      },
    });

var honor = new Swiper(".section7 .mySwiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.82%',
    navigation: {
        nextEl: ".section7  .swiper-button-next",
        prevEl: ".section7  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});